import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Common/Header/Header';
import ContentApp from '../../components/ContentApp';
import { WelletContext } from '../../context/WelletContext';
import styles from './ConfirmAddAccount.module.css';
import Button from '../../components/Common/Button/Button';
import { CircleSpinner } from 'react-spinners-kit';
import { requestStripeOnboardingAccout } from '../../services/requestStripe/requestStripeService';
import ErrorBox from '../../components/Common/ErrorBox/ErrorBox';
import { Spinner } from '../../components/Common/Spinner/Spinner';
import Modal from '../../components/Common/Modal/Modal';
import CheckIconModal from '../../components/icons/CheckIconModal';
import { getBankAccount } from '../../services/withdrawal/withdrawalService';

const AccountDetails = () => {
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const currencies = useSelector((state) => state.currency.all);
  const jwt = useSelector((state) => state.associates.jwt);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [accountInfo, setAccountInfo] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const user = useSelector((state) => state.associates.user);

  const userEmail = user?.email;
  const fetchAccount = async () => {
    try {
      setLoading(true);
      const response = await getBankAccount(welletContext);
      setAccountInfo(response);
    } catch (error) {
      setErrorMessage(error?.response?.data?.errorDescription ?? t('genericError'));
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (accountInfo == null) {
      fetchAccount();
    }
  }, []);
  useEffect(() => {
    if (showSuccessModal) {
      const timer = setTimeout(() => {
        setShowSuccessModal(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showSuccessModal]);

  const handleChangeAccount = async () => {
    try {
      setErrorMessage(null);
      setSendingEmail(true);
      const res = await requestStripeOnboardingAccout(welletContext, jwt);

      if (res.status === 200) {
        setShowSuccessModal(true);
      } else {
        setErrorMessage(true);
      }
    } catch (error) {
      console.error(error);
      setErrorMessage(true);
    } finally {
      setSendingEmail(false);
    }
  };

  return (
    <>
      <Header title={t('bankAccount')} />
      <ContentApp>
        {loading ? (
          <div className='loaderDiv'>
            <CircleSpinner
              className='spinner-app mx-auto'
              style={{ margin: 'auto' }}
              size={40}
              color='var(--color-font-primary)'
            />
          </div>
        ) : (
          accountInfo != null && (
            <>
              <div className='font-tiny text-primary fw-semibold mt-4'>{t('accountData')}</div>
              <div className={`${styles.containerBorder} mt-2 p-3`}>
                   <div className='text-secondary font-tiny'>{t('accountHolderName')}</div>
                <div className='fw-semibold mt-1'>{accountInfo.accountHolderName}</div>

                <div className='text-secondary mt-3 font-tiny'>{t('bank')}</div>
                <div className='fw-semibold mt-1'>{accountInfo.bankName}</div>

                <div className='text-secondary font-tiny mt-3'>{t('accountNumber')}</div>
                <div className='fw-semibold mt-1'>
                  {accountInfo.routingNumber} •••• {accountInfo.last4}
                </div>

                <div className='text-secondary font-tiny mt-3'>{t('currency')}</div>
                <div className='fw-semibold mt-1'>
                  {currencies.find((c) => c.shortForm === accountInfo.currency.toUpperCase())
                    ? currencies.find((c) => c.shortForm === accountInfo.currency.toUpperCase())
                        .name
                    : accountInfo.currency.toUpperCase()}
                </div>
              </div>

              <Button
                text={
                  sendingEmail ? (
                    <div className='d-flex justify-content-center'>
                      <Spinner size={25} color='#000' />
                    </div>
                  ) : (
                    t('changeAccount')
                  )
                }
                size='normal'
                className='mt-3'
                type='button'
                onClick={handleChangeAccount}
                arrow
                color='#000'
                backgroundColor='var(--color-primary)'
                iconColor='#000'
                disabled={sendingEmail}
                loading={sendingEmail}
              />

              {errorMessage && (
                <div className='mt-2'>
                  <ErrorBox title={t('callApiError')} />
                </div>
              )}
            </>
          )
        )}
      </ContentApp>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        showCloseButton={false}
        animationClass='fade'
        hasBackground={true}
      >
        <div className='d-flex flex-column align-items-center justify-content-center'>
          <CheckIconModal size={'50px'} checkColor='#fff' circleColor='#00ba00' />
          <div className='mt-3 fw-600 font-small' style={{ color: '#d9d9d9' }}>
            {t('requestStripe', { email: userEmail })}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AccountDetails;